import React, { useState, useEffect } from 'react';
import { Joyride, STATUS } from 'react-joyride';
import { useAuth } from '../hooks/useAuth';

export function TutorialTour({ type }) {
  const { user } = useAuth();
  const [run, setRun] = useState(false);

  useEffect(() => {
    if (!user?.uid) return;
    const tourKey = `shiksha_tour_${type}_${user.uid}`;
    const hasCompleted = localStorage.getItem(tourKey);
    
    // Only run if not completed
    if (!hasCompleted) {
      // Slight delay to allow DOM to render and IDs to attach
      const timer = setTimeout(() => {
        setRun(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [user, type]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      if (user?.uid) {
        localStorage.setItem(`shiksha_tour_${type}_${user.uid}`, 'true');
      }
    }
  };

  const adminSteps = [
    {
      target: 'body',
      content: 'Welcome to Shiksha-Edge Admin Dashboard! Let me show you around so you can get started.',
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '#tour-admin-stats',
      content: 'Here you can see a high-level overview of total students and teachers currently in the system.',
      placement: 'bottom',
    },
    {
      target: '#tour-manage-teachers',
      content: 'Use this tile to create new teacher accounts and assign them to specific classes and subjects.',
      placement: 'right',
    },
    {
      target: '#tour-udise-ingest',
      content: 'Upload Government UDISE+ CSV files here to automatically ingest bulk student data into the platform.',
      placement: 'left',
    },
    {
      target: '#tour-report-gen',
      content: 'Generate and download beautiful, standardized PDF Report Cards for students once all marks are entered.',
      placement: 'right',
    },
    {
      target: '#tour-rollover',
      content: 'Warning! At the end of the year, use this to archive all data and generate a fresh master sheet for the next Academic Year.',
      placement: 'top',
    },
  ];

  const teacherSteps = [
    {
      target: 'body',
      content: 'Welcome to your Shiksha-Edge Dashboard! Let me give you a quick tour of your tools.',
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '#tour-assigned-classes',
      content: 'These are the specific subjects and classes you have been assigned to. Click on them to enter Marks or Attendance.',
      placement: 'top',
    },
    {
      target: '#tour-class-tools',
      content: 'If you are a Class Teacher, you can generate Report Cards for your entire class here.',
      placement: 'top',
    },
    {
      target: '#tour-sync-section',
      content: 'Tap here to manually sync your offline data with the cloud or to check pending sync items.',
      placement: 'right',
    },
    {
      target: '#tour-recent-activity',
      content: 'Check your submission history here to revert any recent marks or attendance entries.',
      placement: 'left',
    }
  ];

  const steps = type === 'admin' ? adminSteps : teacherSteps;

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      scrollToFirstStep={true}
      showProgress={true}
      showSkipButton={true}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: '#4f46e5', // Indigo-600
          zIndex: 10000,
          backgroundColor: '#ffffff',
          textColor: '#1f2937',
        },
        buttonNext: {
          borderRadius: '6px',
        },
        buttonBack: {
          marginRight: 10,
        }
      }}
    />
  );
}
